module.exports = __webpack_public_path__ + "static/media/logo_mtn.303f8dd6.png";